import { useState } from "react";
import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { BRAND_USED_ON_USERS_ERROR, useDeleteBrandMutation } from "modules/BrandsDashboard/components/DeleteBrandModal/hooks";
import { capitalizeFirstLetter } from "utils/common";

type DeleteBrandModalProps = {
  brandId: number | null;
  onClose: () => void;
};

export const DeleteBrandModal = ({ brandId, onClose }: DeleteBrandModalProps) => {
  const { t } = useTranslation();

  const [isForceDeleteConfirmed, setIsForceDeleteConfirmed] = useState(false);
  const [errorDetail, setErrorDetail] = useState("");

  const { mutate: deleteBrand, isPending: isDeleteBrandPending } = useDeleteBrandMutation();

  const handleClose = () => {
    setIsForceDeleteConfirmed(false);
    setErrorDetail("");
    onClose();
  };

  const handleConfirm = () => {
    if (brandId === null) return;

    deleteBrand(
      { id: brandId, is_confirmed: isForceDeleteConfirmed },
      {
        onSuccess: () => handleClose(),
        onError: error => {
          if (isForceDeleteConfirmed || !BRAND_USED_ON_USERS_ERROR.test(error.message)) return;

          setErrorDetail(capitalizeFirstLetter(error.message));
          setIsForceDeleteConfirmed(true);
        }
      }
    );
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={brandId !== null}
      handleCancel={handleClose}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={
        isForceDeleteConfirmed
          ? `${errorDetail}. ${t("v8_delete_anyway", "Delete anyway?")}`
          : t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")
      }
      handleConfirm={handleConfirm}
      isLoading={isDeleteBrandPending}
    />
  );
};
